export const encodeHttpFilter = (filter: any) => {
   return encodeURIComponent(JSON.stringify(filter));
};